import _ from "lodash";

function getStateNames(statename) {
    var result = ["*", statename];

    if (statename.includes(".")) {
        result.push(statename.split(".")[0]); // check root ie modelname.create also checks 'modelname'
    }

    return result;
}

export function canAccessState(group_permissions, statename) {
    var result = true;

    var stateList = getStateNames(statename);

    _.forEach(stateList, function (astate_name) {
        var hasPermissionEntry = group_permissions[astate_name];

        if (hasPermissionEntry) {
            if (hasPermissionEntry.deny) {
                result = false; // deny
            }
        }
    });

    return result;
}

function canOperation(
    grouppermissions,
    statename,
    modelName,
    fieldName,
    operation
) {
    var result = true; //allow

    var stateList = getStateNames(statename);

    grouppermissions = grouppermissions || {}; // handle No permissions

    _.forEach(stateList, function (astate_name) {
        var state = grouppermissions[astate_name];

        if (state) {
            if (state.deny) {
                return false; // Whole state denied!
            }

            var model = state.models[modelName];

            if (model) {
                var field = model[fieldName];

                if (field) {
                    if (field[operation] == true) {
                        result = false; // disallowed
                    }
                }
            }
        }
    });

    return result;
}

export function canReadField(
    grouppermissions,
    statename,
    modelName,
    fieldName
) {
    return canOperation(
        grouppermissions,
        statename,
        modelName,
        fieldName,
        "deny_read"
    );
}

export function canUpdateField(
    grouppermissions,
    statename,
    modelName,
    fieldName
) {
    return canOperation(
        grouppermissions,
        statename,
        modelName,
        fieldName,
        "deny_update"
    );
}

export function updateSchemaModelWithPermissions(
    group_permissions,
    schemaModel,
    routeName
) {
    var result = _.cloneDeep(schemaModel);

    if (group_permissions && schemaModel) {
        _.forEach(result.fields, function (field) {
            var canRead = canReadField(
                group_permissions,
                routeName,
                result.name,
                field.name
            );
            var canUpdate = canUpdateField(
                group_permissions,
                routeName,
                result.name,
                field.name
            );

            field.permissions = { canRead: canRead, canUpdate: canUpdate };

            field.hide = !canRead;
            field.readonly = !canUpdate;
        });
    }

    return result;
}
